import LeadGeneralReportsPage from "./LeadGeneralReportsPage.layout";

export default LeadGeneralReportsPage;
